import React from 'react';
import { CheckIcon, ShieldCheckIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { offerIncludes, product } from '../data/salesCopy';
export function PricingSection() {
  return <section id="offer" className="scroll-mt-2 bg-brand-sage px-4 py-8 text-brand-ivory sm:py-10" data-id="element-204" data-mp="1eh7b3i8v0tbb">
      <div className="mx-auto max-w-3xl" data-id="element-205" data-mp="1jai8ksrs7xqk">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.2em] text-brand-gold sm:text-xs" data-id="element-206" data-mp="1nakbf5996x7f">
          Special Launch Offer
        </p>
        <h2 className="mt-1 text-center font-serif text-2xl font-extrabold uppercase leading-none text-white sm:text-4xl" data-id="element-207" data-mp="1s82ck9h1484v">
          🧘 {product.name}
        </h2>
        <p className="mt-1.5 text-center text-[11px] font-extrabold uppercase tracking-[0.15em] text-brand-sand sm:text-xs" data-id="element-208" data-mp="2282ze5e3x6dt">
          The Complete Ready-to-Teach System for Yin Yoga Instructors
        </p>

        <div className="mt-4 rounded-xl border-4 border-brand-gold bg-brand-ivory p-4 text-brand-charcoal shadow-2xl sm:p-5" data-id="element-209" data-mp="7utlm1ej2ypr">
          <div className="grid gap-4 sm:grid-cols-[190px_1fr] sm:items-center" data-id="element-210" data-mp="1mi9c99fdp8mf">
            <a href={product.checkoutUrl} className="block transition-transform duration-200 ease-smooth hover:scale-[1.02]" data-id="element-211" data-mp="1hp6cuknx74yb">
              <img src={product.image} alt="YIN YOGA READY™ complete 6-in-1 Yin Yoga teaching system" className="mx-auto w-full max-w-[190px] drop-shadow-xl" data-id="element-212" data-mp="17s1wx2ko45py" />
            </a>

            <div data-id="element-213" data-mp="20hqzvlgxufu7">
              <p className="text-center text-[11px] font-extrabold uppercase tracking-wider text-brand-taupe sm:text-left" data-id="element-214" data-mp="20h90wh2w5nil">
                Complete 6-in-1 Yin Yoga Teaching System
              </p>
              <ul className="mt-2 grid gap-x-4 gap-y-1 sm:grid-cols-2" data-id="element-215" data-mp="1rfhq4xthuqhv">
                {offerIncludes.map(item => <li key={item} className="flex items-start gap-1.5 text-[12px] font-semibold leading-snug sm:text-[13px]" data-id="element-216" data-mp="g0m4grwfjort">
                    <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand-sage" aria-hidden="true" data-id="element-217" data-mp="hforxifdvk3n" />
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="mt-4 border-t border-brand-sand pt-3 text-center" data-id="element-218" data-mp="cgu4222k75co">
            <p className="text-[12px] font-bold text-brand-taupe sm:text-sm" data-id="element-219" data-mp="3uvwa8xkq39aa">
              Normal price:{' '}
              <span className="line-through" data-id="element-220" data-mp="3jbc0dqhzqra">{product.fullPrice}</span>
            </p>
            <p className="font-serif text-5xl font-extrabold leading-none text-brand-sage sm:text-6xl" data-id="element-221" data-mp="3kzt4ziukquj4">
              {product.price}
            </p>
            <p className="mt-1 text-[11px] font-extrabold uppercase tracking-wider text-brand-clay sm:text-xs" data-id="element-222" data-mp="3bxser5xrd8qy">
              🔥 Get YIN YOGA READY™ Today — One-Time Payment
            </p>

            <div className="mx-auto mt-3 max-w-md" data-id="element-223" data-mp="2xb3e30rrspiz">
              <CTAButton href={product.checkoutUrl} subLabel="Immediate Digital Access" data-id="element-224" data-mp="2xbwdthsbaerm">
                🧘 YES! I WANT THE COMPLETE SYSTEM
              </CTAButton>
            </div>

            <div className="mt-3 flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-bold text-brand-charcoal/80 sm:text-xs" data-id="element-225" data-mp="369otin1y3ofj">
              <span className="flex items-center gap-1" data-id="element-226" data-mp="3g95zz6p0u6ck">
                <ZapIcon className="h-3.5 w-3.5 text-brand-gold" aria-hidden="true" data-id="element-227" data-mp="3g7mgz8bzdh73" />
                Immediate Digital Access
              </span>
              <span className="flex items-center gap-1" data-id="element-228" data-mp="3p43sico9bh3d">
                <ShieldCheckIcon className="h-3.5 w-3.5 text-brand-sage" aria-hidden="true" data-id="element-229" data-mp="3l1z0tjhdcujd" />
                🛡️ 14-Day Money-Back Guarantee
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}